export default __webpack_public_path__ + "static/media/twitter-logo.19a624f8.svg";